import styled from "styled-components";
import { themeGet } from "styled-system";

import { useNova } from "pstat-anywhere/context_providers/NovaContext";
import { FocusLink } from "pstat-design-system/Link";

export const LabelFieldContainer = styled.label`
  opacity: 0.9;
  font-family: Roboto;
  font-size: ${props => (props.isNova ? "16" : "14")}px;
  font-weight: ${props => (props.isNova ? "400" : "500")};
  line-height: 1.43;
  text-align: left;
  color: ${props =>
    props.isNova
      ? themeGet("colors.nova.nova-color-typography-base")
      : themeGet("colors.nav.0")};
  margin-bottom: ${props => (props.isNova ? "8" : "7")}px;
  display: block;
`;

export const RequiredLabelContainer = styled(LabelFieldContainer)`
  &:after {
    content: "*";
    color: ${themeGet("colors.messages.error")};
  }
`;

export const LabelField = ({ name, required, htmlFor, url }) => {
  let content = name;
  const isNova = useNova();
  if (url) {
    content = (
      <FocusLink href={url} target="_blank">
        {name}
      </FocusLink>
    );
  }
  return (
    <div>
      {required ? (
        <RequiredLabelContainer htmlFor={htmlFor}>
          {content}
        </RequiredLabelContainer>
      ) : (
        <LabelFieldContainer htmlFor={htmlFor} isNova={isNova}>
          {content}
        </LabelFieldContainer>
      )}
    </div>
  );
};
